export const SEARCH_DEBOUNCE_TIMEOUT = 200

export const THRESHOLD_END_INDEX = 1
